import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-issue-settings-page',
  templateUrl: './issues-settings-page.component.html',
  styleUrls: ['./issues-settings-page.component.scss']
})
export class IssuesSettingsPageComponent {


}
